import React from "react";
import { Tabs, message, Tooltip, Button } from "antd";

import { sanitize_path } from "../../../utils";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";

import Share from "../../../components/FilesShare/share";

import {is_supported_video_format} from "../../../utils"

import "./styles.scss";

// video preview, metadata, sharing, download, transcode

export default class ResultView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      download_url: "",
      play: false,

      share_loading: false,
      slack_channels: [],
      slack_channel: "",
      share_on_slack: "",
      share_recipients: [],
      share_select_all: true,
      share_files: [],
      share_expiration: 604800
    };
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({play: false})
    
    let { file = {}, selected_files = [] } = this.props;
    if (selected_files.length === 1) file = selected_files[0];
    if (is_supported_video_format(file.name) && !file.proxyUrl) {
      this.getDownloadUrl(file)
    }else{
      this.setState({download_url: ''})
    }
  }

  extractGeneralMetadata = metadata => {
    const media = Object.assign({}, metadata);
    delete media["Video"];
    delete media["Audio"];
    return media;
  };

  extractAudioMetadata = metadata => Object.assign({}, metadata["Audio"]);

  extractVideoMetadata = metadata => Object.assign({}, metadata["Video"]);

  on_file_select = index => {
    this.setState({ selected_file_index: index });
  };

  on_delete = file => {
    let $this = this;
    this.setState({ delete_loading: true });
    CloudFlyerAPI.transfer
      .delete_object(file.cloud_account_id, file.bucket.bucket_name, [
        file.path
      ])
      .then(res => {
        $this.setState({ delete_loading: false });
        if (!((res||{}).data||{})) {
          return message.error("failed to delete files, please retry again");
        }
        message.success(((res||{}).data||{}).message || "");
      })
      .catch(err => {
        $this.setState({ delete_loading: false });
        message.error(err);
      });
  };

  getDownloadUrl = (file) => {
    CloudFlyerAPI.transfer
      .download_url(
        file.cloud_account_id,
        file.bucket_name,
        [file.key]
      )
      .then(res => {
        if (!((res||{}).data||{}))
          return message.error(
            "failed to play file , please retry again"
          );
          if (res && res.data && res.data[0])
            this.setState({download_url: res.data[0].url});
      })
  }

  on_download = files => {
    let $this = this;
    $this.setState({ dl_loading: true });

    CloudFlyerAPI.transfer
      .download_url(
        files[0].cloud_account_id,
        files[0].bucket_name,
        files.map(f => f.key)
      )
      .then(res => {
        $this.setState({ dl_loading: false });
        if (!((res||{}).data||{}))
          return message.error(
            "failed to generate download link, please retry again"
          );
        $this.setState({ download_files: [] }, () =>
          $this.setState({ download_files: ((res||{}).data||{}) })
        );
      })
      .catch(err => {
        $this.setState({ dl_loading: false });
        message.error(err);
      });
  };

  on_share = files => {
    let $this = this;

    for (let i = 0; i < files.length; i++) {
      files[i].share = true;
      files[i].basename = files[i].key;
    }

    $this.setState({
      share_visible: true,
      share_select_all: true,
      share_files: files
    });
  };

  on_share_cancel = () => this.setState({ share_visible: false });

  on_share_select = (file, share) => {
    for (let key in this.state.share_files) {
      let item = this.state.share_files[key];
      if (item.basename === file.basename) {
        item.share = share;
        this.setState({
          share_files: this.state.share_files,
          share_select_all: false
        });
        return;
      }
    }
  };

  on_copy_link = file => {
    if (!file) {
      return;
    }

    try {
      let textArea = document.createElement("textarea");
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      textArea.value = file.download_url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    } catch (e) {}

    message.success("Link copied!");
  };

  on_copy_dll = async file => {
    if (!file) {
      return;
    }

    if (!file.download_url)
      return (file.download_url = (await CloudFlyerAPI.transfer.download_url(
        file.cloud_account_id,
        file.bucket_name,
        [file.key]
      )).data[0].url);
    this.on_copy_link(file);
  };

  on_generate_link = (file, hide_message) => {
    let $this = this;
    file.generating_link = true;

    CloudFlyerAPI.transfer
      .download_url(file.cloud_account_id, file.bucket_name, [file.key])
      .then(response => {
        file.generating_link = false;

        if (!((response||{}).data||{})) {
          return message.error(
            "failed to generate download link, please retry again"
          );
        }

        file.download_url = ((response||{}).data||{})[0].url;
        $this.setState({ files: this.state.files });

        if (!hide_message) message.success("Link generated !");
      })
      .catch(err => {
        file.generating_link = false;
        file.download_url = null;
        $this.setState({ files: this.state.files });
        message.error(err);
      });
  };

  on_share_files = files => {
    let $this = this;
    $this.setState({ share_loading: true });

    let share_files = [];

    for (let key in files) {
      share_files.push({
        name: files[key].key,
        size: files[key].size,
        acl: "private",
        bucket_name: files[key].bucket_name,
        cloud_account_id: files[key].cloud_account_id
      });
    }

    if (share_files.length <= 0 || $this.state.share_recipients.length <= 0)
      return;

    CloudFlyerAPI.transfer
      .share_by_email_files({
        files: share_files,
        recipients: $this.state.share_recipients,
        password: $this.state.share_password,
        expiration: $this.state.share_expiration
      })
      .then(() => {
        $this.setState({
          share_visible: false,
          share_loading: false
        });
        message.success("files shared successfully");
      })
      .catch(err => {
        $this.setState({ share_loading: false });
        message.error(err.message);
      });
  };

  on_recipient_change = recipients =>
    this.setState({ share_recipients: recipients });

  on_share_password_change = ({ target }) =>
    this.setState({ share_password: target.value });

  on_share_expiration_change = value =>
    this.setState({ share_expiration: value });

  on_share_select_all = check_all => {
    for (let key in this.state.files) {
      this.state.files[key].share = check_all;
    }

    this.setState({
      files: this.state.files,
      share_select_all: check_all
    });
  };

  togglePlay = () => {
    this.setState({play: !this.state.play})
  }

  render() {
    let { loading, file = {}, selected_files = [] } = this.props;
    const { play, download_url } = this.state;

    if (selected_files.length === 1) file = selected_files[0];

    const { metadata, proxyUrl, key, bucket_name, path, project_name } = file;

    return (
      <div className="file-preview">
        {selected_files.length < 2 ? (
          !selected_files.length ? (
            <div className="empty-state">
              <div className="empty-header" />
              <h2>No file selected</h2>
              <p>Select a file to see metadata</p>
            </div>
          ) : (
            <div className="single-file-preview">
              <div className="empty-header" />
              <SimplePlayer
               proxySrc={proxyUrl}
               play={play || proxyUrl}
               downloadedSrc={download_url}
               />
              <p className="file-name">{key}</p>
              <div className="file-actions">
                <Tooltip placement="bottom" title="Download">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon="download"
                    size="small"
                    onClick={() => this.on_download([file])}
                  />
                </Tooltip>
                <Tooltip placement="bottom" title="Share">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon="share-alt"
                    size="small"
                    onClick={() => this.on_share([file])}
                  />
                </Tooltip>
                <Tooltip placement="bottom" title="Copy download link">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon="copy"
                    size="small"
                    onClick={() => this.on_copy_dll(file)}
                  />
                </Tooltip>
                {is_supported_video_format(file.name) && !proxyUrl && 
                  <Tooltip placement="bottom" title="play video file">
                    <Button
                      ghost
                      type="primary"
                      shape="circle"
                      icon={play ? "pause-circle" : "play-circle"}
                      size="small"
                      onClick={this.togglePlay}
                    />
                  </Tooltip>}
              </div>

              <Tabs
                className="metadata-tabs"
                onChange={() => console.log("tab changed !")}
              >
                <Tabs.TabPane className="metadata-tab" tab="General" key="1">
                  <Entry title="Name" content={key} />
                  <Entry title="Cloud Account" content={project_name} />
                  <Entry title="Bucket Name" content={bucket_name} />
                  <Entry title="Path" content={sanitize_path(path, true)} />
                  <Entries metadata={this.extractGeneralMetadata(metadata)} />
                </Tabs.TabPane>

                <Tabs.TabPane className="metadata-tab" tab="Video" key="2">
                  <Entries metadata={this.extractVideoMetadata(metadata)} />
                </Tabs.TabPane>

                <Tabs.TabPane className="metadata-tab" tab="Audio" key="3">
                  <Entries metadata={this.extractAudioMetadata(metadata)} />
                </Tabs.TabPane>
              </Tabs>
            </div>
          )
        ) : (
          <div className="many-files">
            <div className="empty-header" />
            <div className="actions">
              <h2>Bulk Actions</h2>
              <h3 className="file-name">{`${
                selected_files.length
              } files selected`}</h3>

              <div className="file-actions">
                <Tooltip placement="bottom" title="Download">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon="download"
                    size="small"
                    onClick={() => this.on_download(selected_files)}
                  />
                </Tooltip>
                <Tooltip placement="bottom" title="Share">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon="share-alt"
                    size="small"
                    onClick={() => this.on_share(selected_files)}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        )}

        {this.state.share_visible && (
          <Share
            files={this.state.share_files}
            recipients={this.state.share_recipients}
            visible={this.state.share_visible}
            select_all={this.state.share_select_all}
            loading={this.state.share_loading}
            password={this.state.share_password}
            expiration={this.state.share_expiration}
            channels={[]}
            channel={""}
            share_on_slack={""}
            use_weblink={false}
            on_channel_change={""}
            on_cancel={this.on_share_cancel}
            on_select={this.on_share_select}
            on_copy_link={this.on_copy_link}
            on_generate_link={this.on_generate_link}
            on_share_files={this.on_share_files}
            on_recipient_change={this.on_recipient_change}
            on_password_change={this.on_share_password_change}
            on_expiration_change={this.on_share_expiration_change}
            on_select_all={this.on_share_select_all}
          />
        )}

        <div className={"hidden"}>
          {(this.state.download_files || []).map((file, i) => (
            <iframe key={i} download={file.url} src={file.url} />
          ))}
        </div>
      </div>
    );
  }
}

const SimplePlayer = ({ proxySrc, downloadedSrc, play, }) => (
  <div className="simple-player">
    {(proxySrc || downloadedSrc ) && play ? (
      <video controls autoPlay>
        <source src={(proxySrc || downloadedSrc)} />
        Doesn't support html5 videos
      </video>
    ) : (
      <div/>
    )}
  </div>
);

const Entries = ({ metadata }) => {
  return (
    <div key={new_index()} className="entries">
      {Object.entries(metadata).map(([k, v]) => (
        <Entry key={new_index()} title={k} content={v} />
      ))}
    </div>
  );
};

const Entry = ({ title, content }) => {
  content =
    typeof content === "object" ? <Entries metadata={content} /> : content;
  return (
    <div key={new_index()} className="metadata-entry">
      <div className="title">{title}</div>
      <div className="content">{content}</div>
    </div>
  );
};

let lastIndex = 0;
const new_index = () => {
  lastIndex++;
  return lastIndex;
};
